import { Component, Input, ViewChild } from '@angular/core';
import { PersonsOrganisationDto } from '@flyfreely-portal-ui/flyfreely';
import { GeneralTask } from 'libs/flyfreely/src/lib/services/generalTasks.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GeneralTaskEditComponent } from '../general-task-edit/general-task-edit.component';

@Component({
    selector: 'general-task-details-dialogue',
    templateUrl: './general-task-details-dialogue.component.html',
    styleUrls: ['./general-task-details-dialogue.component.css']
})
export class GeneralTaskDetailsDialogueComponent {
    @Input() taskId: number;
    @Input() organisation: PersonsOrganisationDto;
    @Input() isEditing = false;

    @ViewChild('editTaskDialogue', { static: false })
    editTaskDialogue: GeneralTaskEditComponent;

    task: GeneralTask;

    constructor(
        private modal: BsModalRef<GeneralTaskDetailsDialogueComponent>
    ) {}

    onCancel() {
        this.modal.hide();
    }

    toggleViewEdit() {
        this.isEditing = !this.isEditing;
    }

    onTaskDeleted() {
        this.modal.hide();
    }

    taskUpdated(task: GeneralTask) {
        this.task = task;
        this.toggleViewEdit();
    }
}
